export default __webpack_public_path__ + "static/media/security.1113f104.png";